import React from 'react'
import WebMain from './WebMain'
function TransferBuy() {
    return (
        <WebMain selectedKeys='goods'>            
            <div
                style={{
                    
                    backgroundColor:"#ddd",
                    display:'flex',
                    justifyContent:'center',
                    height:'100vh',
                    padding:'20px',
                    
                }}
            >
                <div
                    style={{
                        width:'100%',
                        maxWidth:'500px',
                        maxHeight:'300px',
                        backgroundColor:'#fff',
                        borderRadius:'10px',
                        padding:'40px',
                        boxShadow:'0 2px 10px rgba(0,0,0,0.1)',
                    }}
                >
                    <h3 style={{textAlign:'center',marginBottom:'20px'}}>转账付款</h3>
                    <p>
                        <b>账户名称：</b>
                        湖北伯纳思网络科技有限公司
                        <a
                            href="#"
                            style={{ marginLeft: 10, fontSize: 12 }}
                            onClick={e => {
                                e.preventDefault();
                                navigator.clipboard.writeText('湖北伯纳思网络科技有限公司');
                            }}
                        >
                            复制
                        </a>
                    </p>
               
                    <p>
                        <b>开&ensp;户&ensp;行：</b>
                        中国建设银行股份有限公司宜昌紫光苑支行
                        <a
                            href="#"
                            style={{ marginLeft: 10, fontSize: 12 }}
                            onClick={e => {
                                e.preventDefault();
                                navigator.clipboard.writeText('中国建设银行股份有限公司宜昌紫光苑支行');
                            }}
                        >
                            复制
                        </a>
                    </p>    
                    <p>
                        <b>银行账号：</b>
                        42250143300700000458
                        <a
                            href="#"
                            style={{ marginLeft: 10, fontSize: 12 }}
                            onClick={e => {
                                e.preventDefault();
                                navigator.clipboard.writeText('42250143300700000458');
                            }}
                        >
                            复制
                        </a>
                    </p>
                    <p style={{marginTop:'20px'}}>转账后请将转账凭证发送到客服微信</p>
                </div>
            </div>
        </WebMain>
    )
}

export default TransferBuy